/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from 'react';

import {
  Row,
  Col,
  Card,
  Radio,
  Table,
  Tag,
  Tooltip,
  message,
  Button,
  Avatar,
  Typography,
  Spin, 
  Space,
  Modal
} from "antd";



import {
  CheckCircleOutlined,
  SearchOutlined,
  FundViewOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
  FileAddOutlined,
  DeleteOutlined,
  LoadingOutlined,
  ShareAltOutlined
} from '@ant-design/icons';

import moment from 'moment';


import NewFirmware from "./../components/NewFirmware";

import {getDFULists,deleteFirmWare} from './../services';




const { confirm } = Modal;
const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 60,
    }}
    spin
  />
);




const data = [];


class Firmware extends React.Component {

      state ={
        usersList :[],
        currentUser:false,
        isLoader:true,
        userListState:[],
        newDblock: false,
      }

  async componentDidMount(){

      this.syncData();

  }

  Columns=()=>{

    // table code start
const columns = [

 {
    title: "DFU Version",
    key: "sw_version",
    dataIndex: "sw_version",
    render:(record)=>{
      return (<Tag color="lime"><b>{record}</b></Tag>);
    }
  },
  {
    title: "DFU Link",
    key: "file_path",
    dataIndex: "file_path",
    render:(record)=>{
      return (<Tag  color="purple">{record} </Tag>);
    }
  },
  // {
  //   title: "Sensor ID",
  //   key: "sensor_id",
  //   dataIndex: "sensor_id",
  //   render:(record)=>{
  //     return (<Tag color="blue">{record}</Tag>);
  //   }
  // },{
  //   title: "ID",
  //   key: "hw_version",
  //   dataIndex: "hw_version",
  //   render:(record)=>{
  //     return (<Tag color="blue">{record}</Tag>);
  //   }
  // }
  ,{
    title: "Status",
    key: "status",
    dataIndex: "status",
    render:(record)=>{
      return (record ? <Tag color="green">Active</Tag> : <Tag color="red">In Active</Tag>);
    }
  },{
    title: "Date of Upload",
    key: "created_at",
    dataIndex: "created_at",
    render:(record)=>{
      const formattedDate = moment(record).format('YYYY-MM-DD HH:mm:ss');
      
      return formattedDate;
    }
  },
  {
    title: "Action",
    key: "id",
    dataIndex: "id",
    render:(record)=>{
      return <Button type="primary" className="dfu_delete" onClick={()=> this.showDeletePromiseModal(record)}  shape="circle" size="small" icon={<DeleteOutlined />} />;
    }
  }
    
];

return columns;

  }
  


   showDeletePromiseModal = (content) => {
    const thisState = this;
    confirm({
      title:"Do you want to Delete this Firmware?",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        return new Promise(async (resolve, reject) => {

          // setTimeout(()=> {

          //   thisState.initUserLists();

          //   resolve(true);
          // },4500);


          const thisData = await deleteFirmWare(content);

          if (thisData.status === "success") {
            message.success(thisData.message);

            thisState.syncData();
            // window.location.reload();
            resolve(true);
          } else {
            message.error(thisData.message);
            reject(true);
          }

          // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
        }).catch(() => console.log("Oops! Something went wrong"));
      },
      onCancel() {


        // console.log("fdsfdf");
        // window.location.reload();

        // thisState.initUserLists();
      },
    });
  };

  syncData = async() => {
   
   let thisMessage  = message;
    thisMessage.loading({
      content: 'Loading...',
      key:'ml_loader'
    });

     
    const {status,data} =  await getDFULists();

    console.log(data);
   
    if(status=="success"){
       thisMessage.success({
        content: 'Loaded.',
        key:'ml_loader',
        duration: 2,
      });
  
      this.setState({
        usersList:data,
        isLoader:false
      });
    }
    
  };


 


  onChange = (e) => console.log(`radio checked:${e.target.value}`);
   render (){

    const {usersList,currentUser,isLoader,newDblock} = this.state;

   return(
    <>
      <div className="tabled">
      
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>

            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={<span>Firmware (DFU) List <Tag color="gold">Total : {usersList.length}</Tag></span>}
              extra={
                 <>
 <NewFirmware open={newDblock}  syncTrigger={()=>this.syncData()} />
                 
      <span> </span>
      <Button
        onClick={()=>this.syncData()}
        type="primary"
        style={{
          marginBottom: 16,
        }}
        icon={<SyncOutlined/>}
      >
        Sync 
      </Button>
                 </>
              }
            >
          
            <Spin indicator={antIcon} spinning={isLoader} >
              <div className="table-responsive">

                <Table
                  rowKey={record => record.id}
                  columns={this.Columns()}
                  dataSource={usersList}
                  pagination={true}
                  className="ant-border-space"
                />
              </div>
              </Spin>
            </Card>

            
          </Col>
        </Row>
      </div>
    </>
  );
    }
}

export default Firmware;
